import styled from '@emotion/styled'
import {
  HeaderExtraLarge600Style,
  TextMedium500Style,
  InfoMediumMaxi500Style,
} from '../../../../../../styles/Text.styles'
import theme from '../../../../../../styles/theme'

export const Divider = styled.hr`
  margin: 0;
  border: none;
  height: 1.5px;
  background: linear-gradient(
    90deg,
    ${theme.colors.backgroundDark} 70%,
    transparent 50%
  );
  background-size: 5px 1px;
`

export const Container = styled.div``

export const HeaderContainer = styled.div`
  padding: 0px 20px 5px 20px;
  margin-top: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
`

export const Title = styled.h2`
  ${HeaderExtraLarge600Style};
  display: block;
`

export const Overview = styled.p`
  ${TextMedium500Style};
  color: ${theme.colors.veryFadedText};
`

export const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
`

export const IconButton = styled.button`
  padding: 0.5rem;
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${theme.colors.fadedText};

  &:hover {
    color: ${theme.colors.standardText};
  }
`

export const ContentContainer = styled.div`
  padding: 2rem;
`

export const AIPlusBadge = styled.div`
  ${InfoMediumMaxi500Style};
  background-color: ${theme.colors.second};
  color: white;
  border-radius: 2rem;
  padding: 0.2rem 1.5rem;
  font-style: italic;
  margin-right: 1rem;
  margin-left: 0.5rem;
`
